import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-single',
  templateUrl: './disable-single.component.html',
  styleUrls: ['./disable-single.component.css'],
})
export class DisableSingleComponent {
  @Input() question!: Question;
}
